import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import routing from "routing";
import newApi from "src/newApi";

import options from "./defaultOptions";

export function useCheckToken(token) {
	const history = useHistory();
	const query = useQuery({
		queryKey: [`validate-token-${token}`],

		queryFn: () => {
			return newApi.validateToken(token);
		},

		...options,
	});

	// TanStack Query 5: bez onError w useQuery
	useEffect(() => {
		if (query.error) history.push(routing.paths.setPasswordError);
	}, [query.error, history]);

	return query;
}
